import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../databaseServices/BaseDatabaseService';
import {GoPay} from '../../classes/GoPay';

@Injectable({
  providedIn: 'root'
})
export class GoPayService extends BaseDatabaseService{

  private collectionName = 'goPay';

  constructor() {
    super();
  }

  getGoPay() {
    return this.db.collection(this.collectionName).get();
  }

  createGoPay(id, goPay: GoPay) {
    goPay.race = this.db.collection('races').doc(goPay.race);
    goPay = Object.assign({}, goPay);

    if (id === undefined || id === 'new') {
      return this.db.collection(this.collectionName).doc().set(goPay);
    } else {
      return this.db.collection(this.collectionName).doc(id).set(goPay);
    }
  }

  getOne(id) {
    return this.db.collection(this.collectionName).doc(id).get();
  }

  delete(id) {
    return this.db.collection(this.collectionName).doc(id).delete();
  }

  getGoPayByRaceId(raceId) {
    return this.db.collection(this.collectionName).orderBy('race').startAt('/races/' + raceId).get();
  }
}
